export const useBlockingLoginAction = <T extends Function>(action: T): (() => void) | T => {
  return action;
};
